import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { LogOut } from 'lucide-react';

import { Button } from '@repo/lib-design-system/primitives/button.component';
import { cn } from '@repo/lib-design-system/utils/tw-merge.util';

import { logout } from './authentication';

export function Logout(): ReactElement {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const onLogout = async (): Promise<void> => {
    logout();
    await navigate({ to: '/login' });
    queryClient.clear();
  };

  return (
    <Button
      size="sm"
      variant="ghost"
      onClick={() => void onLogout()}
      className={cn(
        'gap-1.5 rounded-md text-charcoal-800',
        'hover:bg-grey-100',
        'dark:text-white',
        'dark:hover:bg-white/10'
      )}
    >
      <LogOut className="size-5" />
      {t('header.logout')}
    </Button>
  );
}

export default Logout;
